import { render, staticRenderFns } from "./AssignShipmentDropdown.vue?vue&type=template&id=fa7364bc&scoped=true&"
import script from "./AssignShipmentDropdown.vue?vue&type=script&lang=js&"
export * from "./AssignShipmentDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AssignShipmentDropdown.vue?vue&type=style&index=0&id=fa7364bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7364bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa7364bc')) {
      api.createRecord('fa7364bc', component.options)
    } else {
      api.reload('fa7364bc', component.options)
    }
    module.hot.accept("./AssignShipmentDropdown.vue?vue&type=template&id=fa7364bc&scoped=true&", function () {
      api.rerender('fa7364bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/buttons/AssignShipmentDropdown.vue"
export default component.exports